import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, LayoutDashboard, LogOut, ShoppingBag } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const links = [
  { to: "/#concept", label: "Le Concept" },
  { to: "/#boites", label: "Les Boîtes" },
  { to: "/annuaire", label: "Annuaire" },
  { to: "/concours", label: "Nos Éditions" },
  { to: "/pizzagraphie", label: "Pizzagraphie" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (to) => { setOpen(false); nav(to.startsWith("/#") ? "/" + to.slice(1) : to); };

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200">
      <div className="tricolore-bar h-1 w-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
               className="text-sm font-bold cc-navy hover:text-cc-red transition-colors">{l.label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard-btn" className="btn-navy text-sm inline-flex items-center gap-2 py-2.5 px-4">
                <LayoutDashboard size={16} /> Espace {user.role === "admin" ? "Startup" : user.role === "pizzeria" ? "Pizzeria" : "Client"}
              </Link>
              <button data-testid="nav-logout-btn" onClick={() => { logout(); nav("/"); }} className="text-slate-500 hover:text-cc-red p-2" title="Déconnexion">
                <LogOut size={20} />
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login-btn" className="text-sm font-bold cc-navy hover:text-cc-red">Se connecter</Link>
          )}
          <Link to="/commander" data-testid="nav-order-btn" className="btn-cocarde text-sm inline-flex items-center gap-2 py-2.5 px-5">
            <ShoppingBag size={16} /> Commander
          </Link>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden p-2 cc-navy" data-testid="nav-mobile-toggle"><Menu size={26} /></button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[85%] sm:w-96 bg-white">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="flex flex-col gap-1 mt-6">
              {links.map((l) => (
                <button key={l.to} onClick={() => go(l.to)} data-testid={`mnav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                        className="text-left text-lg font-bold cc-navy py-3 border-b border-slate-100">{l.label}</button>
              ))}
              <Link to="/commander" onClick={() => setOpen(false)} data-testid="mnav-order-btn" className="btn-cocarde text-center mt-4">Commander une Cocarde</Link>
              {user ? (
                <>
                  <Link to="/dashboard" onClick={() => setOpen(false)} data-testid="mnav-dashboard-btn" className="btn-navy text-center mt-2">Mon espace</Link>
                  <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="mt-3 text-slate-500 font-semibold">Déconnexion</button>
                </>
              ) : (
                <Link to="/login" onClick={() => setOpen(false)} data-testid="mnav-login-btn" className="text-center mt-3 font-bold cc-navy">Se connecter</Link>
              )}
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
